'use strict';
const mmWidgets = require('../widgets/mm-widgets');

mmWidgets.fn.mmScrollIntoView = function () {

	const domElement = this.domElements[0],
		scrollfunc = domElement && (domElement.scrollIntoViewIfNeeded || domElement.scrollIntoView);

	if (scrollfunc) {
		scrollfunc.apply(domElement, [false]);
	}
	return this;
};
